import React from 'react';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import {UserContext} from '../../UserContext';
import {Form, Submit, CenterVert} from './styled';
import {default as StyledButton} from '../../components/Button';
import {api} from '../../services/api';
import { Label } from '../../components/Form/Input/styled';
import NumberFormat from 'react-number-format';
import Alert from '../../components/Alert';
import { PriceSimulatorProps } from '../../interfaces';
import Select from '../../components/Form/Select';
import Modal from '../../components/Modal';

export function currencyFormatter(value: any) {
    if (!Number(value)) return "";
  
    const amount = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value / 100);
  
    return `${amount}`;
}

var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',    
});  

const ufs = [
    {id: 'AL', description: "Alagoas"},
    {id: 'AP', description: "Amapá"},
    {id: 'BA', description: "Bahia"},
    {id: 'DF', description: "Distrito Federal"},
    {id: 'ES', description: "Espírito Santo"},
    {id: 'MG', description: "Minas Gerais"},
    {id: 'PE', description: "Pernambuco"},
    {id: 'PR', description: "Paraná"},
    {id: 'RJ', description: "Rio de Janeiro"},
    {id: 'RS', description: "Rio Grande do Sul"},
    {id: 'SE', description: "Sergipe"},
];

const PriceSimulator: React.FC = () => {
    document.title = "Simulador de Preços - Sultan Veste a Casa";

    const preco = useForm('notEmpty');
    const codigo = useForm('notEmpty');
    const uf_para = useForm('notEmpty');

    const [simulation, setSimulation] = React.useState<PriceSimulatorProps>();
    const [price, setPrice] = React.useState();

    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');
    const [openConfirm, setOpenConfirm] = React.useState(false);

    const {loading, setLoading} = React.useContext(UserContext);

    const onSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try{
            setLoading(true);

            await api.get(`/simulator/exist/${codigo.value}`);
            
            const {data} = await api.post('/simulator/list', {
                codigo: codigo.value,
                para_uf: uf_para.value
            });
            
            if(data.nPerMVAAjustado > 0){
                new Error('Produto sem ST');
            }

            setSimulation(data.product);
            
            const calc = await api.post('/simulator/calc', {
                codigoProduto: data.product.sCodigo,
                ufOrigem: data.product.sDeUF,
                ufDestino: data.product.sParaUF,
                precoDeVenda: preco.value.replace(/[^0-9,]*/g, '').replace(',', '.'),
            });

            setPrice(calc.data.infos.PrecoDeVendaComST);
            setOpenConfirm(true);
        }catch(error){
            setError(error.message);
        }finally{
            setLoading(false);
        }
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleModal = () => {
        setOpenConfirm(false);
    }

    return (
        <Container>    
            <CenterVert>                    
                <Form className="shadow" onSubmit={onSubmit}>                                           
                    <Select 
                        label="Estado de Destino: *" 
                        required
                        id="destino" 
                        {...uf_para} 
                        options={ufs}
                    />                 
                    <Input 
                        label="Código do Produto:" 
                        id="codigo"
                        type="number" 
                        {...codigo}
                        required
                    />
                    <Label htmlFor="valor">Valor: </Label>
                    <NumberFormat
                        type="text"
                        value={preco.value}
                        customInput={Input}
                        onValueChange={(values) => {
                            const {formattedValue} = values;
                            preco.setValue(formattedValue);
                        }}
                        format={currencyFormatter}
                        required
                    />
                    <Submit>
                        {loading ? <StyledButton type="submit" disabled>Carregando...</StyledButton> :
                            <StyledButton type="submit">Calcular</StyledButton>}
                    </Submit>    
                </Form>                                    
            </CenterVert>
            <Modal
                open={openConfirm}  
                onClose={handleModal}           
                titleModal={"Calculo de Preço com ST"}
                message={`O resultado do calculo para o produto ${simulation?.sCodigo} é de: ${formatter.format(parseFloat(`${price}`))}`}
                textConfirm={"OK"}
            />
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>
        </Container>
    )
}

export default PriceSimulator;
